<template>
  <div id="page-wrapper" v-if="loggedIn">
    <div class="bill-row">
      <p class="bill-row__name">{{ selectedServiceProvider }}</p>
    </div>
    <BillSummary :billDetail="billResponse.billDetail" v-if="billResponse" />

    <form class="bill-pay__form" @submit.prevent="proceedToPay">
      <div class="bill-pay__form__row" v-if="billResponse">
        <div class="bill-pay__form__row__radio-row">
          <!-- <input
            type="radio"
            name="pay-mode"
            id="pay-mode"
            class="bill-pay__form__row__radio-row__radio"
            value="1"
          />-->
          <!-- v-model="payment_mode" -->
          <label for="pay-mode" class="bill-pay__form__row__radio-row__label">
            <div class>
              <p class="bill-pay__form__row__radio-row__label__title">Total Amount</p>
              <p
                class="bill-pay__form__row__radio-row__label__value"
              >₹ {{ billResponse.billDetail.netAmount }}</p>
            </div>
            <button
              class="bill-pay__form__row__radio-row__label__details"
              type="button"
              @click="showDetails = !showDetails"
            >{{ showDetails ? 'Hide Details' : 'View Details' }}</button>
          </label>
        </div>
        <template v-if="showDetails">
          <hr />
          <div class="bill-pay__form__row__details">
            <div class="bill-pay__form__row__details__row">
              <p class="bill-pay__form__row__details__row__title">Transaction Amount</p>
              <p
                class="bill-pay__form__row__details__row__value"
              >₹ {{ billResponse.billDetail.amount }}</p>
            </div>
            <div class="bill-pay__form__row__details__row">
              <p class="bill-pay__form__row__details__row__title">Convenience Fee</p>
              <p
                class="bill-pay__form__row__details__row__value"
              >₹ {{ billResponse.billDetail.custConvFee }}</p>
            </div>
            <!-- <div class="bill-pay__form__row__details__row">
              <p class="bill-pay__form__row__details__row__title">GST</p>
              <p class="bill-pay__form__row__details__row__value">₹ 0</p>
            </div>-->
          </div>
        </template>
      </div>

      <div class="bill-pay__form__row" v-if="!billResponse">
        <div class="bill-pay__form__row__radio-row">
          <!-- <input
            type="radio"
            name="pay-mode"
            id="pay-mode-other"
            class="bill-pay__form__row__radio-row__radio"
            value="2"
          />-->
          <!-- v-model="payment_mode" -->
          <label for="pay-mode" class="bill-pay__form__row__radio-row__label">
            <div class="rupee">
              <input
                type="number"
                class="bill-pay__form__row__radio-row__label__input"
                v-model="billAmount"
              />
            </div>
          </label>
        </div>
      </div>
      <p class="text-error text-center mt-30" v-if="pageError">{{ pageError }}</p>
      <ActionButton title="Pay Now" />
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BillSummary from "@/components/BillSummary/index";
import ActionButton from "@/components/ActionButton/index";
export default {
  name: "bill",
  data() {
    return {
      query: {},
      pageError: "",
      showDetails: false,
      billAmount: this.billResponse
        ? this.billResponse.billDetail.netAmount
        : "",
    };
  },
  props: ["category", "billResponse", "queryData"],
  computed: {
    ...mapGetters(["loggedIn", "selectedServiceProvider", "selectedBillFetch"]),
  },
  components: { BillSummary, ActionButton },
  methods: {
    proceedToPay() {
      this.query = this.queryData;
      this.query.transactionInfo.description = this.selectedServiceProvider;
      this.query.transactionInfo.amount = this.billAmount;
      delete this.query.transactionInfo.name;
      if (this.billResponse) {
        this.query.transactionInfo.requestId = this.billResponse.transactionInfo.requestId;
      }
      if (this.selectedBillFetch) {
        delete this.query.transactionInfo.questions;
      }
      if (this.billAmount) {
        this.$store.dispatch("selectPlan", {
          amount: this.billAmount,
          description: "",
        });
        this.pageError = "";
        this.$store
          .dispatch("createTxn", {
            params: this.query,
          })
          .then((response) => {
            const status =
              response.responseCode + "" === "-10"
                ? "PENDING"
                : response.responseCode + "" === "0"
                ? "APPROVED"
                : "DECLINED";
            if (typeof ePayLater !== "undefined" && ePayLater.paymentStatus) {
              ePayLater.paymentStatus(
                status,
                this.billAmount,
                status !== "PENDING"
                  ? response.responseInfo.responseDescription
                  : 'Your order is taking longer than expected. We will notify you if the transaction is successful. You can also check "Bill payments and Recharge History" for latest status.',
                response.transactionInfo.transactionNumber
                  ? response.transactionInfo.transactionNumber
                  : ""
              );
            } else if (
              typeof window.webkit !== "undefined" &&
              typeof window.webkit.messageHandlers !== "undefined" &&
              typeof window.webkit.messageHandlers.EpayLater !== "undefined" &&
              typeof window.webkit.messageHandlers.EpayLater.postMessage !==
                "undefined"
            ) {
              window.webkit.messageHandlers.EpayLater.postMessage(
                JSON.stringify({
                  status: status,
                  amount: this.billAmount.toString(),
                  description:
                    status === "APPROVED"
                      ? ""
                      : response.responseInfo.responseDescription,
                  transactionId: response.transactionInfo.transactionNumber,
                })
              );
            } else {
              if (response.responseCode + "" === "0") {
                this.$router.push({
                  name: "EplNewTransactionSuccess",
                  params: {
                    category: this.category,
                    type: this.$route.params.category,
                    transactionInfo: response.transactionInfo,
                  },
                });
              } else if (response.responseCode + "" === "-1") {
                this.$router.push({
                  name: "EplNewTransactionFail",
                  params: {
                    category: this.category,
                    type: this.$route.params.category,
                    message: response.responseDescription,
                  },
                });
              } else {
                this.$router.push({
                  name: "EplNewTransactionPending",
                  params: {
                    category: this.category,
                    type: this.$route.params.category,
                    responseMessage: {
                      responseDescription:
                        'Your order is taking longer than expected. We will notify you if the transaction is successful. You can also check "Bill payments and Recharge History" for latest status.',
                    },
                  },
                });
              }
            }
          })
          .catch((err) => {
            if (typeof ePayLater !== "undefined" && ePayLater.paymentStatus) {
              ePayLater.paymentStatus(
                "DECLINED",
                0.0,
                err.response && err.response.data && err.response.data.message
                  ? err.response.data.message
                  : "Failed due to unknown reason",
                err.response &&
                  err.response.data &&
                  err.response.data.transactionInfo &&
                  err.response.data.transactionInfo.transactionNumber
                  ? err.response.data.transactionInfo.transactionNumber
                  : ""
              );
            } else if (
              typeof window.webkit !== "undefined" &&
              typeof window.webkit.messageHandlers !== "undefined" &&
              typeof window.webkit.messageHandlers.EpayLater !== "undefined" &&
              typeof window.webkit.messageHandlers.EpayLater.postMessage !==
                "undefined"
            ) {
              window.webkit.messageHandlers.EpayLater.postMessage(
                JSON.stringify({
                  status: "DECLINED",
                  amount: "0.0",
                  description:
                    err.response &&
                    err.response.data &&
                    err.response.data.message
                      ? err.response.data.message
                      : "Failed due to unknown reason",
                  transactionId:
                    err.response &&
                    err.response.data &&
                    err.response.data.transactionInfo &&
                    err.response.data.transactionInfo.transactionNumber
                      ? err.response.data.transactionInfo.transactionNumber
                      : "",
                })
              );
            } else {
              this.$router.push({
                name: "EplNewTransactionFail",
                params: {
                  category: this.category,
                  type: this.$route.params.category,
                  responseMessage: {
                    responseDescription:
                      err.response &&
                      err.response.data &&
                      err.response.data.message
                        ? err.response.data.message
                        : "Failed due to unknown reason",
                  },
                },
              });
            }
          });
      }
    },
  },
};
</script>
<style lang="scss">
.bill-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: #fff;
  padding: 12px 27px;
  color: #4d4d4d;
  &__name {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 0;
  }
  &__image {
    margin-left: 1rem;
    width: 100px;
  }
}

.bill-pay {
  &__form {
    padding: 0 27px;
    &__row {
      background: #ffffff;
      margin: 20px 0;
      &__radio-row {
        padding: 14px 0px;
        // display: grid;
        // grid-template-columns: auto 1fr;
        align-items: center;
        grid-gap: 20px;
        &__radio {
          appearance: none;
          position: relative;
          display: block;
          cursor: pointer;
          border: solid 0.2px #d4d4d4;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          &:checked {
            &::after {
              background: #3482fd;
              content: "";
              width: 10px;
              height: 10px;
              border-radius: 50%;
              display: block;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              padding: 0;
              border: none;
            }
            border: solid 0.2px #3482fd;
            outline: none;
          }
          &:focus {
            outline: none;
          }
          &::after {
            display: block;
            text-align: center;
            color: rgba(0, 0, 0, 0.4);
            border: solid 0.05rem black;
            padding: 0.5rem 2rem 0.5rem 0.5rem;
            border-radius: 0.32rem;
            font-size: 1.6rem;
          }
        }
        .rupee {
          position: relative;
          &:before {
            position: absolute;
            content: "₹";
            left: 10px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 19px;
          }
        }
        &__label {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0;
          width: 100%;
          &__title {
            font-size: 12px;
            font-weight: 300;
            color: #4d4d4d;
            margin-bottom: 0;
          }
          &__value {
            font-size: 20px;
            font-weight: 900;
            color: #4d4d4d;
            margin-bottom: 0;
          }
          &__details {
            font-size: 16px;
            color: #3482fd;
            margin-bottom: 0;
            background: #fff;
            outline: none;
            border: none;
            padding: 0;
          }
          &__input {
            font-size: 20px;
            padding: 8px 16px;
            &::placeholder {
              font-size: 16px;
              color: #d6d4d4;
            }
            padding-left: 25px;
            width: 100%;
            border-radius: 3px;
            border: solid 0.5px #d4d4d4;
            background-color: #ffffff;
            &:focus {
              outline: solid 1px #3482fd;
            }
          }
        }
      }
      &__details {
        &__row {
          display: grid;
          grid-template-columns: 2fr 1fr;
          justify-content: space-between;
          font-size: 14px;
          color: #4d4d4d;
          &__value {
            text-align: right;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bill.vue